/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ArrowSort16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2a1 1 0 011 1v7.586l2.293-2.293a1 1 0 111.414 1.414l-3.988 3.988a.999.999 0 01-1.426.012l-4-4a1 1 0 011.414-1.414L7 10.586V3a1 1 0 011-1z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default ArrowSort16;
